<template>
  <div class="mm-table-sorter">
    <ui-icon
      :active="store.operations.sortColumn === column && store.operations.sortOrder"
      name="up"
      size="10px"
      fill="#898989"
      hover-fill="#1890ff"
      active-fill="#1890ff"
      @click="sort(column, true)"></ui-icon>
    <ui-icon
      :active="store.operations.sortColumn === column && !store.operations.sortOrder"
      name="down"
      size="10px"
      fill="#898989"
      hover-fill="#1890ff"
      active-fill="#1890ff"
      @click="sort(column, false)"></ui-icon>
  </div>
</template>

<script>
import isFunction from "lodash/isFunction"
import Icon from "../icon"

export default {
  name: "mm-table-sorter",
  components: {
    "ui-icon": Icon,
  },
  props: {
    column: Object,
    store: Object,
  },
  inject: {
    rootTable: {
      from: "mm-table",
      default: null,
    },
  },
  methods: {
    sort(column, ascending) {
      const data = {
        column,
        order: this.store.getSortAlias(ascending),
      }

      this.store.setSort(column, ascending)

      if (isFunction(this.rootTable.onSort)) {
        this.rootTable.onSort(data)
      }

      this.rootTable.$emit("sort", data)
    },
  },
}
</script>
